(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__shippingBarInit) return;
    window.__shippingBarInit = true;

    var originalFetch = window.fetch;

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency,
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function update(cart) {
      document.querySelectorAll('[data-shipping-bar]').forEach(function (bar) {
        var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
        var textEl = bar.querySelector('[data-shipping-bar-text]');
        var fillEl = bar.querySelector('[data-shipping-bar-fill]');
        if (!textEl || !fillEl || !threshold) return;

        var total = cart.total_price;
        var remaining = threshold - total;
        var progress = Math.min(100, Math.round((total / threshold) * 100));

        if (cart.item_count === 0) {
          textEl.textContent = bar
            .getAttribute('data-text-empty')
            .replace('[amount]', formatMoney(threshold, cart.currency));
        } else if (remaining > 0) {
          textEl.textContent = bar
            .getAttribute('data-text-progress')
            .replace('[amount]', formatMoney(remaining, cart.currency));
        } else {
          textEl.textContent = bar.getAttribute('data-text-done');
        }

        fillEl.style.width = progress + '%';
      });
    }

    function refresh() {
      originalFetch('/cart.js', { cache: 'no-store' })
        .then(function (r) {
          return r.json();
        })
        .then(update)
        .catch(function () {});
    }

    // Sepet isteklerini yakala (ekleme, değiştirme, silme)
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var promise = originalFetch.apply(this, args);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        promise
          .then(function () {
            setTimeout(refresh, 80);
          })
          .catch(function () {});
      }
      return promise;
    };

    document.addEventListener('cart:update', function () {
      setTimeout(refresh, 80);
    });

    window.addEventListener('pageshow', refresh);
  })();

  } catch(e) { console.error(e); }
})();
})();
